import { Cell, Pie, PieChart } from "recharts";
import { ResponseAggregatesRpc } from "../../lib/discordTypes";

type StepSurvey = {
  configs: {
    message: string;
    options: { emoji: string; id: string; label: string; skipDefer: boolean };
  };
};
type Props = {
  data: ResponseAggregatesRpc[];
};
function SurveyCard({ data }: Props) {
  // const supabase = getSupaClient();
  const question = data[0].question;
  const totalResponses = data[0].step_responses;
  const COLORS = [
    "#0088FE",
    "#00C49F",
    "#FFBB28",
    "#FF8042",
    "#FF679C",
    "#BDFF72",
    "#FFC773",
    "#9EEDFF",
    "#B89EFF",
    "#FF4F4F",
  ];
  const dataForChart = data.map((d) => {
    return { ...data, name: d.answer, value: d.count };
  });

  const RADIAN = Math.PI / 180;
  const renderCustomizedLabel = ({
    cx,
    cy,
    midAngle,
    innerRadius,
    outerRadius,
    percent,
  }: any) => {
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > cx ? "start" : "end"}
        dominantBaseline="central"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };
  // --- Commented for now, it can be usefull in the next version to fetch all possible options ----

  // const getTriggerStep = async () => {
  //   const { data: step_info, error } = await supabase
  //     .from<StepSurvey>("trigger_steps")
  //     .select("*")
  //     .match({ id: data[0].step_id, trigger_id: triggerId });
  //   console.log("step_info:");
  //   console.log(step_info);
  //   if (step_info) {
  //     console.log(step_info[0]);
  //     setQuestion(step_info[0].configs.message);
  //   }
  //   console.log(error);
  // };

  // useEffect(() => {
  //   getTriggerStep();
  // }, []);

  return (
    <div
      className="p-5 flex flex-col items-center rounded-lg border border-gray-100 flex-1"
      style={{ maxWidth: "500px" }}
    >
      <p className="m-0 text-left w-full">{question}</p>
      <p className="text-left w-full text-xs font-light">
        {totalResponses} responses
      </p>
      <PieChart width={210} height={210} className="mt-2">
        <Pie
          data={dataForChart}
          cx="50%"
          cy="50%"
          labelLine={false}
          label={renderCustomizedLabel}
          innerRadius={60}
          outerRadius={100}
          paddingAngle={1}
          fill="#8884d8"
          dataKey="value"
        >
          {data.map((_entry, index) => (
            <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
          ))}
        </Pie>
      </PieChart>
      <div className="flex gap-3 flex-wrap mt-5 justify-center">
        {data.map((d, idx) => (
          <div className="flex gap-1 justify-center items-center text-xs">
            <div
              className="w-3 h-3 "
              style={{ backgroundColor: COLORS[idx % COLORS.length] }}
            />
            <p className="m-0">{d.answer}</p>
            <p className="text-gray-500 m-0">({d.count})</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SurveyCard;
